export default {
  // การตั้งชื่อตัวแปร จะต้องมีชื่อ component อยู่ข้างหน้า
  en: {
    log_out: 'Log out',
    login_checkbox: 'Remember me',
    login_validate_username: '*Please enter your username',
    login_validate_password: '*Please enter your password',
    btnStatus_title_cancel: 'Cancel the project',
    btnStatus_des_cancel: 'Are you sure you want to cancel this project ?',
    btnStatus_title_delete: 'Delete the project',
    btnStatus_des_delete: 'Are you sure you want to delete this project ?',
    btnStatus_title_hold: 'Hold the project',
    btnStatus_des_hold: 'Are you sure you want to hold this project ?',
    btnStatus_title_unhold: 'Unhold this project',
    btnStatus_des_unhold: 'Are you sure you want to unhold  this project ?',
    btnStatus_title_rejectKickoff: 'Reject (Kick off) this project ',
    btnStatus_title_rejectRegis: 'Reject (Register) this project ',
    btnStatus_title_rejectHold: 'Reject (Hold) this project ',
    btnStatus_title_rejectComplete: 'Reject (Complete) this project ',
    btnStatus_des_reject: 'Are you sure you want to reject ? ',
    btnStatus_title_skip: 'Cancel approval of the project',
    btnStatus_des_skip: 'Are you sure you want to cancel approval of the project ?',
    btnStatus_title_complete: 'Complete Project',
    btnStatus_des_complete: 'Are you sure you want to complete project ?',
    btnStatus_title_kickoff: 'Kick off Project',
    btnStatus_des_kickoff: 'Are you sure you want to kick off project ?',
    btnStatus_title_approveRegis: 'Approve (Register) this project',
    btnStatus_title_approveKickoff: 'Approve (Kick off) this project',
    btnStatus_title_approveHold: 'Approve (Hold) this project',
    btnStatus_title_approveComplete: 'Approve (Complete) this project',
    btnStatus_title_approve: 'Approve (Kick off) this project',
    btnStatus_des_approve: 'Are you sure you want to approve ?',
    btnStatus_title_save: 'Saved Succesfully',
    btnStatus_des_save: 'Your project has been saved',
    btnStatus_title_register: 'Register Project',
    btnStatus_des_register: 'Are you sure you want to register project ?',

    project_copy_title: 'Copy Project',
    project_copy_des: 'Are you sure you want to copy project ?',
    project_information_ProjectName: '*Please enter your project name',
    project_information_ProjectDescription: 'Not require',
    project_information_ProjectGoal: 'Not require',
    project_information_Company: '*Please enter your company name',
    project_information_Operation: '*Please enter your operation name',
    project_information_SubOperation: '*Please enter your project type name',
    project_information_Projectgroup: '*Please enter your project group',
    project_information_ProjectCategory: '*Please enter your project category',
    project_information_ImpactType: '*Please enter your stage',
    project_information_CompanyHolidays: '*Please enter your company  holidays',
    project_information_Duration: '*Please enter your duration',
    project_information_Kick_off_date: '*Please enter your kick off date',
    project_information_Planned_Closured_Date: '*Please enter your planned closured date',

    Project_role_Search_By_skill_name: 'Not require',
    Project_role_Add_role: 'Not require',
    Project_role_Add_member: 'Not require',
    Project_role_Defaultpermission: 'Not require',
    Project_role_Dashboard: 'Not require',

    'Project_KPI/Finance_KPI_Type': '*Please enter your KPI type',
    'Project_KPI/Finance_Input_type': '*Please enter your input type',
    'Project_KPI/Finance_Name': '*Please enter your name',
    'Project_KPI/Finance_Min/Max': '*Please enter your min/max',
    'Project_KPI/Finance_Unit': '*Please enter your unit',
    'Project_KPI/Finance_Goal': '*Please enter your goal',
    'Project_KPI/Finance_GoalMax': 'The maximum length is 16 digits, including decimals.',
    'Project_KPI/Finance_Delete_des':
      'Are you sure you want to delete this KPI/Finance ?',
    'Project_KPI/Finance_Delete_title': 'Delete the KPI/Finance',
    'Project_KPI/Finance_Type_support_need': '*Please enter your type support need',
    'Project_KPI/Finance_Remark': 'Not require',

    addtask_information_Name: '* Please enter your task name',
    addtask_information_TaskType: '* Please enter your task type',
    addtask_information_Line_Name: '* Please enter your line name',
    addtask_information_Planned: '* Please enter your plan date',
    addtask_information_Working_hours_per_day:
      '* Please enter your working hours per day',
    addsubtask_information_Email_Days: '* Please enter email days',
    addsubtask_information_ondelay_Days: '* Please enter on delays',
    addtask_information_checklist_Type_Checklist: '* Please enter your checklist type',
    addtask_information_checklist_Name_Checklist: '* Please enter your checklist name',
    addsubtask_information_Name: '* Please enter your subtask name',
    // task inbox
    choise_reject_title: 'Reject this task',
    choise_reject_des: 'Are you sure you want to reject ?',
    warning_done_title: 'Done Task',
    done_task_title: 'Are you sure you want to done task ?',
    done_task_des: 'If you done task , all the assignee will not be able to update tasks',
    warning_done_des:
      ' Are you sure you want to done task without update KPI/Finance and send mail of support need ?',
    warning_actual_done_des:
      ' Are you sure you want to done task without update KPI/Finance ?',
    warning_mail_done_des:
      '  Are you sure you want to done task without update send mail of support need ?',
    tooltip_btn_done:
      'Cannot complete the task because the sub task have not been completed',
    tooltip_btn_done_required: 'Please check requiredd checklist',

    //supportneedTask
    addtask_supportneed_remark: '* Please enter your remark',
    addtask_supportneed_typesupportneed: '* Please enter your type support need',

    subtask_copy_title: 'Copy Sub Task',
    subtask_copy_des: 'Are you sure you want to copy Sub Task ?',

    Taskinbox_Actualdate: '*Please enter your actual date',
    // List File Upload  - Modal Delete
    delete_file_all_title: 'Delete All ?',
    delete_file_all_des: 'Are you sure you want to delete all this list ?',
    delete_file_select_title: 'Delete this',
    delete_file_select_des: 'Are you sure you want to delete',
    Upload_listfile_delete_title: 'Delete this file',
    Upload_listfile_delete_des: 'Are you sure you want to delete this file ?',
    // management Admin
    delete_unitmeasurment_title: 'Delete unit measurement',
    delete_unitmeasurment_des: 'Are you sure you want to delete unit measurement ?',
    delete_company_title: 'Delete  company',
    delete_company_des: 'Are you sure you want to delete company ?',
    delete_operation_title: 'Delete  operation',
    delete_operation_des: 'Are you sure you want to delete operation ?',
    delete_sub_operation_title: 'Delete  project type',
    delete_sub_operation_des: 'Are you sure you want to delete project type ?',
    delete_project_group_title: 'Delete strategic perspective',
    delete_project_group_des: 'Are you sure you want to delete strategic perspective ?',
    delete_project_cat_title: 'Delete strategic direction',
    delete_project_cat_des: 'Are you sure you want to delete strategic direction ?',
    delete_strategic_imperative_title: 'Delete strategic imperative',
    delete_strategic_imperative_des:
      'Are you sure you want to delete strategic imperative ?',

    delete_project_profess_title: 'Delete professional skills',
    delete_project_profess_des: 'Are you sure you want to delete professional skills ?',

    delete_support_cat_title: 'Delete support category',
    delete_support_cat_des: 'Are you sure you want to delete support category ?',
    delete_project_impacttype_title: 'Delete stage',
    delete_project_impacttype_des: 'Are you sure you want to delete stage?',
    delete_bu_title: 'Delete  business unit',
    delete_bu_des: 'Are you sure you want to delete business unit ?',
    delete_kpi_title: 'Delete  KPI/Finance type',
    delete_kpi_des: 'Are you sure you want to delete KPI/Finance type ?',
    delete_role_title: 'Delete  role and permission',
    delete_role_des: 'Are you sure you want to delete role and permission ?',
    delete_powerbi_title: 'Delete  Power BI Report',
    delete_powerbi_des: 'Are you sure you want to delete Power BI Report ?',
    delete_auth_adfs_title: 'Delete Adfs',
    delete_auth_adfs_adfs: 'Are you sure you want to delete Adfs?',
    cant_delete_powerbi_title: 'Cannot delete Power BI Report',
    cant_delete_powerbi_des:
      'Power BI Report cannot be deleted because it’s connected to user',
    cant_delete_role_title: 'Cannot delete role and permission',
    cant_delete_role_des:
      'Role and permission cannot be deleted because it’s connected to project',
    cant_delete_unit_title: 'Cannot delete  unit measurement',
    cant_delete_unit_des:
      'Unit measurement cannot be deleted because it\'s connected to project',
    cant_delete_impacttype_title: 'Cannot delete stage',
    cant_delete_impacttype_des:
      'Stage cannot be deleted because it\'s connected to project',
    cant_delete_company_title: 'Cannot delete  company',
    cant_delete_company_des:
      'Company cannot be deleted because it\'s connected to project',
    cant_delete_operation_title: 'Cannot delete  operation',
    cant_delete_operation_des:
      "Operation cannot be deleted because it's connected to project",
    cant_delete_sub_operation_title: 'Cannot delete  project type',
    cant_delete_sub_operation_des:
      "Project type cannot be deleted because it's connected to project",
    cant_delete_project_group_title: 'Cannot delete  strategic perspective',
    cant_delete_project_group_des:
      "Strategic perspective cannot be deleted because it's connected to project",
    cant_delete_project_cat_title: 'Cannot delete strategic direction',
    cant_delete_project_cat_des:
      "Strategic direction cannot be deleted because it's connected to project",
    cant_delete_strategic_imperative_title: 'Cannot delete strategic imperative',
    cant_delete_strategic_imperative_des:
      "Strategic imperative cannot be deleted because it's connected to project",
    cant_delete_benefit_type_title: 'Cannot delete benefit type',
    cant_delete_benefit_type_des:
      "Benefit type cannot be deleted because it's connected to project",
    cant_delete_project_profess_title: 'Cannot delete professional skills',
    cant_delete_project_profess_des:
      'Professional skills cannot be deleted because it’s connected to project',

    cant_delete_support_cat_title: 'Cannot delete support category',
    cant_delete_support_cat_des:
      'Support category cannot be deleted because it’s connected to project',
    cant_delete_bu_title: 'Cannot delete  business unit',
    cant_delete_bu_des:
      'Business unit cannot be deleted because it’s connected to project',
    cant_delete_kpi_title: 'Cannot delete KPI/Finance type',
    cant_delete_kpi_des:
      'KPI/Finance type cannot be deleted because it’s connected to project',

    cant_delete_auth_adfs_title: 'Cannot delete auth adfs',
    cant_delete_auth_adfs:
      'Auth adfs type cannot be deleted because it’s connected to project',

    management_cant_delete_title: 'Cannot Delete',
    management_cant_delete_des: 'cannot be deleted because it\'s connected to project',
    err_impact_code: 'Stage code already exists',
    err_impact_itemused: 'Stage cannot transfer because it\'s connected to project',
    err_bu_code: 'Business unit code already exists',
    err_unit_code: 'Unit measurement code already exists',
    err_kpi_code: 'KPI/Finance Type code already exists',
    err_report_code: 'Report code already exists',
    err_role_code: 'Role code already exists',
    err_kpi_itemused:
      'KPI/Finance Type cannot transfer because it’s connected to project.',
    err_supportcat_code: 'Support category code already exists',
    err_supportcat_itemused:
      'Support category cannot transfer because it’s connected to project.',
    err_professionskills_code: 'Professional skill code already exists',
    err_professionskills_itemused:
      'Professional skill cannot transfer because it’s connected to project.',

    err_suboperation_code: 'Project type code already exists',
    err_suboperation_itemused:
      'Project type cannot transfer because it’s connected to project',
    err_operation_code: ' Operation code already exists',
    err_operation_itemused:
      ' Operation cannot transfer because it’s connected to project',
    err_company_code: ' Company code already exists',
    err_company_itemused: ' Company cannot transfer because it’s connected to project',

    err_Holiday_code: ' Holiday already exists',
    err_Holiday_itemused: ' Holiday cannot transfer because it’s connected to project',

    'Admin/Holiday_Detail_Delete_title': 'Delete  holiday detail',
    'Admin/Holiday_Detail_Delete_des': 'Are you sure you want to delete holiday detail ?',
    'Admin/Holiday_Delete_title': 'Delete  holiday',
    'Admin/Holiday_Delete_des': 'Are you sure you want to delete holiday ?',
    'Admin/Account_title': 'Delete  User',
    'Admin/Account_des': 'Are you sure you want to delete user ?',
    'Admin/Account_title_cant': 'Cannot delete user',
    'Admin/Account_des_cant': `User cannot be deleted because it's connected to project`,
    cant_delete_Holiday_title: 'Cannot delete  holiday',
    cant_delete_Holiday_des:
      'Holiday cannot be deleted because it’s connected to project',
    btnStatus_title_uploadHoliday: 'Uploaded Successfully',
    btnStatus_des_uploadHoliday:
      'Your file has been uploaded success 1 and fail 2 from 3 row',
    btnStatus_title_uploadFailHoliday: 'Upload Failed',
    btnStatus_des_uploadFailHoliday: 'Your file was not uploaded',

    Search: 'Search',
    Reset: 'Reset',
    Company: 'Company',
    Local_business_name: 'Local business name',
    English_business_name: 'English business name',
    Short_name: 'Short name',
    ABBR_name: 'ABBR name',
    Operation: 'Operation',
    Local_operation_name: 'Local operation name',
    English_operation_name: 'English operation name',
    Sub_operation: 'Project type',
    Local_sub_operation_name: 'Local project type name',
    English_sub_operation_name: 'English project type name',
    Add_Business: 'Add Business',
    Add_Operation: 'Add Operation',
    Add_Sub_Operation: 'Add Project type',
    Edit_Business: 'Edit Business',
    Edit_Operation: 'Edit Operation',
    Edit_Sub_Operation: 'Edit Project type',
    Add: 'Add',
    Sub_Operation: 'Project type',
    Please_add: 'Please add',
    in_your_project_optional: 'in your project (optional)',
    Save: 'Save',
    Delete: 'Delete',
    CancelProject: 'Cancel Project',
    CancelApproval: 'Cancel Approval',
    Hold: 'Hold',
    CancelApproval: 'Cancel Approval',
    Business_Code: 'Business Code',
    Local_Name: 'Local Name',
    English_Name: 'English Name',
    Short_Name: 'Short Name',
    ABBR_Name: 'ABBR Name',
    Tax_ID_Type: 'Tax ID Type',
    Tax_ID: 'Tax ID',
    Create_by: 'Create by',
    Local_Address: 'Local Address',
    English_Address: 'English Address',
    Post_Code: 'Post Code',
    Bank_Code: 'Bank Code',
    Telephone: 'Telephone',
    E_Mail: 'E-Mail',
    Use_The_Template: 'Use The Template',
    Website: 'Website',
    Operation_Code: 'Operation Code',
    Sub_Operation_Code: 'Project type Code',
    Local_name: 'Local name',
    English_name: 'English name',
    Holiday_date: 'Holiday date',
    Remark: 'Remark',
    Please_add_Holiday_in_your_project_optional:
      'Please add Holiday in your project (optional)',
    Add_Holiday_Detail: 'Add Holiday Detail',
    Holiday_Detail: 'Holiday Detail',
    Templete: 'Templete',
    List: 'List',
    Import: 'Import',
    Export: 'Export',
    Add_Detail: 'Add Detail',
    in: 'in',
    Import_Holiday_detail: 'Import Holiday detail',
    Import_User: 'Import User',
    Upload: 'Upload',
    Upload_Document: 'Upload Document',
    Drag_and_drop_here: 'Drag and drop here',
    or: 'or',
    browse: 'browse',
    Validation_Successful: 'Validation Successful',
    Invalid_File: 'Invalid File',
    Message: 'Message',
    Row: 'Row',
    Upload_File: 'Upload File',
    Your_file_has_been_uploaded_success: 'Your file has been uploaded success',
    rows: 'rows',
    Update: 'Update',
    Edit: 'Edit',
    Holiday_date_already_exists: 'Holiday date already exists.',
    Local_holiday_name: 'Local holiday name',
    English_holiday_name: 'English holiday name',
    Create_date: 'Create date',
    Last_update_date: 'Last update date',
    Holiday: 'Holiday',
    Username: 'Username',
    Advanced_Filter: 'Advanced Filter',
    Please_select_additional_business_that_you_would_like_to_be_displayed_in_the_Executive_Dashboard:
      '*Please select additional business that you would like to be displayed in the Executive Dashboard.',
    Avatar_optional: 'Avatar (optional)',
    Click_to_Change_Image_File: 'Click to Change Image File',
    Name: 'Name',
    Lastname: 'Lastname EN',
    Name_TH: 'Name TH',
    Lastname_TH: 'Lastname TH',
    BU: 'BU',
    Role: 'Role',
    Default_Role: 'Default Role',
    Email: 'Email',
    Phone: 'Phone',
    Languaue: 'Language',
    Thai: 'Thai',
    English: 'English',
    New_Password: 'New Password',
    Password_have_at_least_10_characters_and_strength:
      'Password have at least 10 characters and strength',
    Confirm_Password: 'Confirm Password',
    Status_Active: 'Status Active',
    Last_login: 'Last login',
    Status: 'Status',
    Failed_to_upload_pictures: 'Failed to upload pictures.',
    cant_change_password: `Can't change password`,
    email_already_exists: 'Email already exists',
    Edit_User: 'Edit User',
    Next: 'Next',
    Export_User: 'Export User',
    Add_User: 'Add User',
    Please_add_user_in_your_project_optional:
      'Please add user in your project (optional)',
    Add_user: 'Add_user',
    Click_to_upload_image: 'Click to upload image',
    Export_failed: 'Export failed',
    User: 'User',
    Link_Company: 'Link Company',
    Link_Business: 'Link Business',
    All_Company: 'All Company',
    All_Business: 'All Business',
    Full_name: 'Full name',
    Skills: 'Skills',
    No_Data_Member: 'No Data Member',
    of: 'of',
    results: 'results',
    Professional_skills: 'Professional skills',
    All: 'All',
    Skills_Selected: 'Skills Selected',
    Select_professional_skills: 'Select professional skills',

    //sprint task flow
    //task
    addtask_tab_subtask: 'Sub Task',
    addtask_link_backtosprinttask: 'Back to Sprint (Task) Flow',
    addtask_title_task: 'Task',
    addtask_title_keyaction: 'Key action',
    addtask_tab_information: 'Information',
    addtask_tab_assignee: 'Assignee',
    addtask_tab_kpi: 'KPI/Finance',
    addtask_tab_checklist: 'Check List',
    addtask_tab_supportneed: 'Support Need',
    //subtask
    addtask_title_subtask: 'Subtask',
    addtask_title_sub_keyaction: 'Sub - key action',
    addtask_modaldelete_subtask_title: 'Delete Sub Task',
    addtask_modaldelete_subtask_des: 'Are you sure you want to delete sub task ?',
    //information
    addtask_information_title_name: 'Name',
    addtask_information_title_description: 'Description',
    addtask_information_title_deliverable: 'Deliverable',
    addtask_information_title_planned: 'Planned',
    addtask_information_title_duration: 'Duration (Days)',
    addtask_information_title_totalworkinghour: 'Total Working Hour',
    addtask_information_title_workinghourperday: 'Working hours per day',
    addtask_information_title_workingday: 'Working day (Days) ',
    addtask_information_title_comments: 'Comments/Prods are allowed?',
    addtask_information_value_comments_yes: 'Yes',
    addtask_information_value_comments_no: 'No',
    addtask_information_title_tasktype: 'Task Type',
    addtask_information_value_tasktype_mandatory: 'Mandatory',
    addtask_information_value_tasktype_optional: 'Optional',
    addtask_information_title_emailnoti: 'E-mail Notification',
    addtask_information_value_emailnoti_start: 'On Start',
    addtask_information_value_emailnoti_end: 'On End',
    addtask_information_value_emailnoti_update: 'On Update',
    addtask_information_value_emailnoti_beforedue: 'Before Start',
    addtask_information_unit_beforedue: 'Days',
    addtask_information_value_emailnoti_delays: 'On Delays',
    addtask_information_unit_emailnoti_delays: 'Days',
    addtask_information_btn_save: 'Save',
    //assignee
    addtask_assignee_title_rolename: 'Role / Name',
    addtask_assignee_title_skills: 'Skills',
    addtask_assignee_title_permission: 'Permissions',
    addtask_assignee_value_assignee: 'Assignee',
    addtask_assignee_title_member: 'Members',
    //checklist
    addtask_information_title_checklist_name: 'Name',
    addtask_information_title_checklist_type: 'Type',
    addtask_information_title_checklist_req: 'Required',
    addtask_information_title_checklist_action: 'Action',
    addtask_information_word_checklist_create:
      'Please create Check List in your project (optional)',
    addtask_information_btn_checklist_create: 'Create New',
    addtask_information_title_checklist_checklist: 'Check List',
    addtask_information_btn_checklist_addnew: 'Add New',
    addtask_information_title_modal_checklist: 'Edit Checklist',
    addtask_information_title_modal_checklist_type: 'Type Checklist',
    addtask_information_title_modal_checklist_name: 'Name',
    addtask_information_title_modal_checklist_required: 'Required',
    addtask_information_title_modal_delete_checklist_title: 'Delete Check List',
    addtask_information_title_modal_delete_checklist_des:
      'Are you sure you want to delete check list ?',
    //kpi
    addtask_kpi_menu_edit: 'Edit',
    addtask_kpi_menu_delete: 'Delete',
    addtask_kpi_title_taskgoalminmax: 'Task Goal Min - Max/unit',
    addtask_kpi_title_subtaskgoalminmax: 'Subtask Goal Min - Max/unit',
    addtask_kpi_title_taskgoalunit: 'Task Goal/unit',
    addtask_kpi_title_subtaskgoalunit: 'SubTask Goal/unit',
    addtask_kpi_title_projectgoalminmax: 'Project Goal Min - Max/unit',
    addtask_kpi_title_projectgoalunit: 'Project Goal/unit',
    addtask_kpi_title_projectkpi: 'Project KPI/Finance',
    addtask_kpi_title_kpifinance: 'KPI/Finance',
    addtask_kpi_title_kpitype: 'KPI Type',
    addtask_kpi_title_remaining: 'Remaining',
    addtask_kpi_title_taskkpi: 'Task KPI/Finance',
    addtask_kpi_btn_addtaskkpi: 'Add Task KPI/Finance',
    addtask_kpi_title_emptyproject: 'Project KPI/Finance',
    addtask_kpi_title_emptystate: 'Empty State',
    addtask_kpi_title_emptytask: 'Task KPI/Finance',
    addtask_kpi_btn_addnewtaskkpi: 'Add New Task KPI/Finance',
    addtask_kpi_title_modaladd_projectminmax: 'Project Min/Max',
    addtask_kpi_title_modaladd_projectgoal: 'Project Goal',
    addtask_kpi_title_modaladd_taskminmax: 'Task Min/Max',
    addtask_kpi_title_modaladd_taskgoal: 'Task Goal',
    addtask_kpi_title_name: 'Name',
    addtask_kpi_title_inputtype: 'InputType',
    addtask_kpi_title_unit: 'Unit',
    addtask_kpi_alert_modaltaskgoal_validamount: '*Please enter a valid amount',
    addtask_kpi_alert_modaltaskgoal_goalsbetween:
      '*Please enter your goals between goals',
    addtask_kpi_title_modaltaskgoal_taskgoal: 'Task Goals',
    addtask_kpi_title_modaltaskgoal_cancelvalue: 'Cancel value',
    addtask_kpi_title_modaltaskgoal_update: 'Update',
    addtask_kpi_alert_modaltaskminmax_validmin: '*Please enter a valid min',
    addtask_kpi_alert_modaltaskminmax_validmax: '*Please enter a valid max',
    addtask_kpi_title_modaltaskminmax_taskminmax: 'Task Goals Min-Max',

    //support need
    addtask_supportneed_btn_sendmail: 'Send Mail',
    addtask_supportneed_title_remark: 'Remark',
    addtask_supportneed_title_type: 'Type',
    addtask_supportneed_title_status: 'Status',
    addtask_supportneed_value_status: 'Done',
    addtask_supportneed_title_action: 'Action',
    addtask_supportneed_btn_addnew: 'Add New',
    addtask_supportneed_word_pleaseadd:
      'Please add Support Need in your project (optional)',
    addtask_supportneed_btn_addnewsupp: 'Add New Support Need',
    addtask_supportneed_title_modal_type: 'Type support need',
    addtask_supportneed_title_modal_remark: 'Remark',
    addtask_supportneed_title_modaldelete_title: 'Delete Support need',
    addtask_supportneed_title_modaldelete_des:
      'Are you sure you want to delete this support need ?',

    // dashboard
    kos_title: 'Project in Progress (kick off stage)',
    kos_kickoff_date: 'kick off date',
    overdue_title: 'Project Overdue',
    days: 'days',
    day: 'day',

    // reschedule
    title_err_auto: 'This project can’t be automatically reschedule',
    des_err_overlap_auto:
      'If you want to use “Auto” mode for reschedule,  make sure each of your task schedules must not overlap',
    des_err_working_day:
      'If you want to use “Auto” mode for reschedule,  make sure each of your task schedules working days must not be 0',
    des_err_status_auto:
      'If you want to use “Auto” mode for reschedule,  make sure each of your task status must not be “In progress” or “Done”',
    des_err_status_overlap: `If you want to use “Auto” mode for reschedule,  make sure each of your task status must not be “In progress” or “Done”
    and task schedules must not overlap`,
    des_err_overlap_working_day: `If you want to use “Auto” mode for reschedule,  make sure each of your task schedules must not overlap
    and working days must not be 0`,
    des_err_status_working_day: `If you want to use “Auto” mode for reschedule,  make sure each of your task status must not be “In progress” or “Done”
    and  working days must not be 0`,
    des_err_status_overlap_working_day: `If you want to use “Auto” mode for reschedule,  make sure each of your task status must not be “In progress” or “Done” and task schedules must not overlap
    and working days must not be 0`,
    des_err_flow:
      'If you want to use “Auto” mode for reschedule,  make sure each of your task flow must order by date',
    title_save_reschedule: 'Save Reschedule',
    des_save_reschedule: 'Are you sure you want to reschedule ?',

    // activity
    title_activity: 'Project Activity',
    rq_approve: 'has requested approval',
    has_event: 'has',

    // ลองเปลี่ยน word เป็นคำเดียวกัน
    reason: 'reason',
    no_data: 'No Data',
    requested_approval: 'requested approval',
    has: 'has',
    Search: 'Search',
    Reset: 'Reset',
    Delete: 'Delete',
    Save: 'Save',
    Unit_Code: 'Unit Code',
    Unit_code: 'Unit code',
    Local_Name: 'Local Name',
    Local_name: 'Local name',
    ABBR_Name: 'ABBR Name',
    ABBR_name: 'ABBR name',
    Company: 'Company',
    Business: 'Business',
    Company_Code: 'Company Code',
    Impact_type: 'Stage',
    Impact_Type_Code: 'Stage Code',
    Add_Unit_Measurement: 'Add Unit Measurement',
    Add_Business_Unit: 'Add Business Unit',
    Add_Impact_Type: 'Add Stage',
    Add_Support_Category: 'Add Support Category',
    Add_KPI_Finance_Type: 'Add KPI/Finance Type',
    Add_Project_Group: 'Add Strategic Perspective',
    Add_Professional_Skill: 'Add Professional Skill',
    Add_Project_Category: 'Add Strategic Direction',
    Add_Strategic_Imperative: 'Add Strategic Imperative',
    Add_Role: 'Add Role',
    All_Project_List: 'All Project List',
    All_Project_List_Admin: 'All Project List Admin',
    All_Task_Inbox: 'All Task Inbox',
    All: 'All',
    Admin_Management: 'Admin Management',
    Business_Unit: 'Business Unit',
    Business_Unit_Code: 'Business Unit Code',
    Business_unit_code: 'Business unit code',
    Category_Code: 'Direction Code',
    Imperative_code: 'Imperative Code',
    Create: 'Create',
    Create_Edit: 'Create/Edit',
    Create_Project: 'Create Project',
    Copy: 'Copy',
    Description: 'Description',
    Day_Left: 'Day Left',
    Data_Analytics: 'Data Analytics',
    KPI_Finance_Type: 'KPI/Finance Type',
    KPI_Finance_type: 'KPI/Finance type',
    KPI_Finance_Type_Code: 'KPI/Finance Type Code',
    English_Name: 'English Name',
    English_name: 'English name',
    English_Business_Unit_Name: 'English Business Unit Name',
    English_business_unit_name: 'English business unit name',
    English_Impact_Type_Name: 'English Stage Name',
    English_Support_Category_Name: 'English Support Category Name',
    English_KPI_Finance_Type_Name: 'English KPI/Finance Type Name',
    English_KPI_Finance_type_name: 'English KPI/Finance type name',
    Formula_Target_more_than: 'Formula Target > 0',
    Formula_Target_less_than: 'Formula Target < 0',
    English_Skill_Name: 'English Skill Name',
    English_Skill_name: 'English Skill name',
    English_Group_Name: 'English Perspective Name',
    English_Category_Name: 'English Direction Name',
    English_Imperative_Name: 'English Imperative Name',
    Edit: 'Edit',
    Project_Progress_Update: 'Project Progress Update',
    Executive_Dashboard: 'Executive Dashboard',
    Group_Code: 'Perspective Code',
    Group_code: 'Perspective code',
    History: 'History',
    HelpDesk: 'HelpDesk',
    Holiday: 'Holiday',
    Impact_Type: 'Stage',
    Create_by: 'Create by',
    Create_Date: 'Create Date',
    Category_code: 'Direction code',
    Imperative_code: 'Imperative code',
    Completed: 'Completed',
    iPROJECT: 'iPROJECT',
    Local_Business_Unit_Name: 'Local Business Unit Name',
    Local_business_unit_name: 'Local business unit name',
    Local_Impact_Type_Name: 'Local Stage Name',
    Local_Support_Category_Name: 'Local Support Category Name',
    Local_KPI_Finance_Type_Name: 'Local KPI/Finance Type Name',
    Local_KPI_Finance_type_name: 'Local KPI/Finance type name',
    Local_Skill_Name: 'Local Skill Name',
    Local_Skill_name: 'Local Skill name',
    Local_Group_Name: 'Local Perspective Name',
    Local_Category_Name: 'Local Direction Name',
    Local_Imperative_Name: 'Local Imperative Name',
    List_Professional: 'List Professional',
    Last_Update_Date: 'Last Update Date',
    Menu: 'Menu',
    Management: 'Management',
    Number_of_users: 'Number of users',
    Non_completed: 'Non completed',
    Not_due: 'Not due',
    No: 'No',
    Overview: 'Overview',
    Operation: 'Operation',
    Please_add_unit_measurement: 'Please add Unit Measurement in your project (optional)',
    Please_add_business_unit: 'Please add Business Unit in your project (optional)',
    Please_add_impact_type: 'Please add Stage in your project (optional)',
    Please_add_support_category: 'Please add Support Category in your project (optional)',
    Please_add_KPI_finance_type: 'Please add KPI/Finance Type in your project (optional)',
    Please_add_professional_skills:
      'Please add Professional Skills in your project (optional)',
    Please_add_project_group:
      'Please add Strategic Perspective in your project (optional)',
    Please_add_project_category:
      'Please add Strategic Direction in your project (optional)',
    Please_add_strategic_imperative:
      'Please add Strategic Imperative in your project (optional)',
    Please_add_role_and_permssion:
      'Please add Role and Permssion in your project (optional)',
    Permission: 'Permission',
    Professional_Skills: 'Professional Skills',
    Professional_skills: 'Professional skills',
    Planed_Closured_Date: 'Planed Closured Date',
    Project: 'Project',
    project: 'project',
    projects: 'projects',
    Project_Information: 'Project Information',
    Project_Skills: 'Project Skills',
    Project_Role: 'Project Role',
    Project_KPI_Finance: 'Project KPI/Finance',
    Project_Aging: 'Project Aging',
    Project_Category: 'Strategic Direction',
    Strategic_Imperative: 'Strategic Imperative',
    Project_Group: 'Strategic Perspective',
    Project_Activity: 'Project Activity',
    Project_List: 'Project List',
    Project_Summary: 'Project Summary',
    Project_Status: 'Project Status',
    Project_Name: 'Project Name',
    Role: 'Role',
    Role_name: 'Role name',
    Role_Code: 'Role Code',
    Role_Name: 'Role Name',
    Role_and_Permission: 'Role and Permission',
    Reschedule: 'Reschedule',
    Review_task: 'Review task',
    Are_you_sure_you_want_to_review: 'Are you sure you want to review this task ?',
    Start_creating_your_project: 'Start creating your project',
    Support_code: 'Support code',
    Support_Category_Code: 'Support Category Code',
    Skill_Code: 'Skill Code',
    Skill_code: 'Skill code',
    Summary_Dashboard: 'Summary Dashboard',
    Support_Category: 'Support Category',
    Support_need: 'Support need',
    Sub_operation: 'Project type',
    Sprint_Task_Flow: 'Sprint(Task) Flow',
    Summary: 'Summary',
    Task_Inbox: 'Task Inbox',
    Total: 'Total',
    View: 'View',
    Unit_Measurement: 'Unit Measurement',
    Unit_measurement: 'Unit measurement',
    User_Management: 'User Management',
    Upcoming_Due_Date: 'Upcoming Due Date',
    VS: 'VS',
    Your_Project_List: 'Your Project List',
    Your_Task_Inbox: 'Your Task Inbox',
    Custom_Auth_ADFS: 'Custom Auth ADFS',
  },

  th: {
    login_checkbox: 'Remember me',
    login_validate_username: '*กรุณาระบุชื่อผู้ใช้',
    login_validate_password: '*กรุณาระบุรหัสผ่าน',
    btnStatus_title_cancel: 'Cancel the project',
    btnStatus_des_cancel: 'Are you sure you want to cancel this project ?',
    btnStatus_title_delete: 'Delete the project',
    btnStatus_des_delete: 'Are you sure you want to delete this project ?',
    btnStatus_title_hold: 'Hold the project',
    btnStatus_des_hold: 'Are you sure you want to hold this project ?',
    btnStatus_title_unhold: 'Unhold this project',
    btnStatus_des_unhold: 'Are you sure you want to unhold  this project ?',
    project_information_ProjectName: '*กรุณาระบุชื่อโปรเจกต์',
    project_information_ProjectDescription: 'Not require',
    project_information_ProjectGoal: 'Not require',
    project_information_Company: '*กรุณาระบุชื่อบริษัท',
    project_information_Operation: '*กรุณาระบุโอเปอร์เรชัน',
    project_information_SubOperation: '*กรุณาระบุซับโอเปอร์เรชัน',
    project_information_Projectgroup: '*กรุณาระบุกลุ่มโปรเจกต์',
    project_information_ProjectCategory: '*กรุณาระบุประเภทโปรเจกต์',
    project_information_ImpactType: '*กรุณาระบุขั้นตอน',
    project_information_CompanyHolidays: '*กรุณาระบุวันหยุดของบริษัท',
    project_information_Duration: '*กรุณาระบุประเภทของเวลา',
    project_information_Kick_off_date: '*กรุณาระบุวันที่เริ่มโปรเจกต์',
    project_information_Planned_Closured_Date: '*กรุณาระบุวันที่สิ้นสุดโปรเจกต์',

    Project_role_Search_By_skill_name: 'Not require',
    Project_role_Add_role: 'Not require',
    Project_role_Add_member: 'Not require',
    Project_role_Defaultpermission: 'Not require',
    Project_role_Dashboard: 'Not require',

    'Project_KPI/Finance_KPI_Type': '*Please enter your KPI type',
    'Project_KPI/Finance_Input_type': '*Please enter your input type',
    'Project_KPI/Finance_Name': '*Please enter your name',
    'Project_KPI/Finance_Min/Max(%)': '*Please enter your min/max(%)',
    'Project_KPI/Finance_Unit': '*Please enter your unit',
    'Project_KPI/Finance_Goal': '*Please enter your goal',
    'Project_KPI/Finance_Type_support_need': '*Please enter your type support need',
    'Project_KPI/Finance_Remark': 'Not require',

    addtask_information_Name: '*กรุณาระบุชื่องาน',
    addtask_information_Planned: '*กรุณาระบุวันที่เริ่มต้นและสิ้นสุดของงาน',
    addtask_information_Working_hours_per_day: '*กรุณาระบุจำนวนชั่้วโมงการทำงานต่อวัน',
    addtask_information_checklist_Type_Checklist: '* Please enter your type checklist',
    addtask_information_checklist_Name_Checklist: '* Please enter your name checklist',
    addsubtask_information_Name: '* Please enter your subtask name',

    Taskinbox_Actualdate: '*Please enter your actual date',
    project_copy_title: 'คัดลอก โปรเจค',
    Custom_Auth_ADFS: 'Custom Auth ADFS',
  },
}
